/* Ürün sayfası video ölçümü (27 Eyl 2026, 1 haftalık video testi). Kayıt: LifeOS/01-Projects/BCB-PDP-Kalite-Hatti.md, "Video testi".
   Yalnız GÖRÜLEREK izlenen süre sayılır: video oynuyor, sekme açık ve videonun en az yarısı ekranda.
   Süre, ölçüm noktaları arasındaki medya zamanı artışlarından birikir; tekrar izleme sayılır. Durum değişince (görünürlük,
   sekme, hız) önce eski durumla o ana kadarki aralık sayılır, sonra ölçüm noktası şimdiki konuma çekilir; sarma sayılmaz.
   Olaylar (video öğesi başına her biri bir kez):
     bcb_video_play      görülerek izleme başladı (otomatik oynatmada = gösterim)
     bcb_video_3s        3 sn gerçek süre görülerek izlendi (playbackRate'e bölünür)
     bcb_video_progress  percent 25/50/75/95: görülerek izlenen medya süresi / video süresi
     bcb_video_unmute    sesi açtı (huni basamağı değil, gösterime bağlı ayrı dönüşüm)
   Alanlar: product_id, video_file, autoplay (galeride öne alınıp kodla sessiz oynatılan test videosu). PostHog before_send kişi bazlı %25 örnekler; oranın paydası da örneklenmiş olmalı.
   ponytail: öğe başına durum; galeri video öğesini yeniden oluşturursa yeni öğe bağlanmaz (bugünkü galeri oluşturmuyor). */
(function () {
  var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
  var pid = meta && meta.id ? String(meta.id) : null;
  function bind(v) {
    var sent = {}, inView = !('IntersectionObserver' in window), hid = document.hidden, rate = v.playbackRate || 1;
    var last = v.currentTime, on = !v.paused, media = 0, wall = 0;
    function send(ev, extra) {
      var key = ev + (extra && extra.percent || '');
      if (sent[key] || !window.posthog || typeof posthog.capture !== 'function') return;   // PostHog gelmeden düşmesin: sonraki ölçümde yeniden dener
      sent[key] = 1;
      var p = { product_id: pid, video_file: (v.currentSrc || '').split('?')[0].split('/').pop(), autoplay: !!(v.autoplay || v.closest('[data-bcb-video-test]')) };
      for (var k in extra) p[k] = extra[k];
      posthog.capture(ev, p);
    }
    // Son ölçüm noktasından bu yana geçen aralığı, o aralıktaki durumla (görünür, sekme açık, oynuyor, hız) sayar.
    // `on`: play/pause olaylarıyla tutulur; duraklatmanın timeupdate'i paused=true iken gelir, son aralık yine sayılmalı.
    function add(t) {
      var d = last === null ? 0 : t - last;
      last = t;
      if (!on || hid || !inView || !(d > 0)) return;
      media += d;
      wall += d / rate;
      send('bcb_video_play', {});
      if (wall >= 3) send('bcb_video_3s', {});
      if (v.duration > 0) [25, 50, 75, 95].forEach(function (q) { if (100 * media / v.duration >= q) send('bcb_video_progress', { percent: q }); });
    }
    function flush() { if (v.seeking) last = v.currentTime; else add(v.currentTime); }   // kuyruktaki timeupdate sarmayı sayamaz
    function mark() { last = v.currentTime; }
    v.addEventListener('timeupdate', flush);
    v.addEventListener('play', function () { on = true; mark(); });   // duraklamadan çıkış: aralık buradan başlar
    v.addEventListener('pause', function () { flush(); on = false; });  // doğal bitişte de gelir (ended'dan önce)
    v.addEventListener('seeking', function () {
      // loop başa sararken ended gelmez: son aralık videonun sonuna kadar sayılır. ponytail: son 0,5 sn içinden elle geri sarma da böyle sayılır (en çok 0,5 sn).
      if (v.loop && last !== null && v.duration - last < 0.5) add(v.duration);
      last = null;
    });
    v.addEventListener('seeked', mark);
    v.addEventListener('ratechange', function () { flush(); rate = v.playbackRate || 1; });
    document.addEventListener('visibilitychange', function () { flush(); hid = document.hidden; mark(); });
    v.addEventListener('volumechange', function () { if (!v.muted && v.volume > 0) send('bcb_video_unmute', {}); });
    if (!inView) new IntersectionObserver(function (es) {
      flush();
      es.forEach(function (e) { inView = e.isIntersecting && e.intersectionRatio >= 0.5; });
      mark();
    }, { threshold: [0, 0.5, 1] }).observe(v);
  }
  function scan() { Array.prototype.forEach.call(document.querySelectorAll('video'), bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
